import { Component, Prop, Mixins } from 'vue-property-decorator';
import forgotPass from '@/store/modules/forgotPassword';
import APP_CONST from '@/constants/AppConst';
import AccountSettings from '@/mixins/accountSettings.mixin';
import DeviceWidthCheckerMixin from '@/mixins/deviceWidthChecker.mixin';
import { ScreenText } from '@/lang/ScreenText';


@Component
export class ForgotPassword extends Mixins(DeviceWidthCheckerMixin, AccountSettings) {
  private objScreenText: ScreenText = new ScreenText();
  email: string = '';
  error: string = '';
  closePopup: boolean = false;
  errorBorder: boolean = false;
  emailCheck: boolean | string = '';
  errorMessage: string = '';

    @Prop()
      refSource!: any;

    get linkResponse() {
      return forgotPass.linkVerification;
    }

    onKeyUp() {
      this.errorBorder = false;
      this.errorMessage = '';
    }

    onClick() {
      this.$gtm.trackEvent({
        event: null,
        category: 'ForgotPassword',
        action: 'click',
        label: 'Forgot Pass Click Event Activated',
        value: 5000,
        noninteraction: false,
      });
    }

    public getScreenText(key: string): string {
      return this.objScreenText.getScreenText(key);
    }

    mounted() {
      if (this.$route !== undefined && this.$gtm !== undefined) {
        this.$gtm.trackView(this.$route.name, this.$route.path);
      }
      this.email = '';
    }

    validateEmail(mail: string) {
      const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(mail);
    }

    async sendEmail() {
      if (!this.email) {
        this.errorBorder = true;
        this.errorMessage = this.getScreenText('ERROR_INVALID_EMAIL');
        return;
      }
      this.errorBorder = false;
      const email = this.email
        ? this.email.trim()
        : this.email;
      if (!this.validateEmail(email)) {
        this.errorBorder = true;
        this.errorMessage = this.getScreenText('ERROR_INVALID_EMAIL');
        return;
      }
      this.errorBorder = false;
      await forgotPass.resetPassLink({ email:this.email, refSource: this.refSource});
      if (forgotPass.linkVerification.status == APP_CONST.RESPONSE_200) {
        this.$emit('openEmailSentPopup');
        this.clearEmail();
      }
      else if (forgotPass.linkVerification.status == APP_CONST.RESPONSE_400) {
        this.errorBorder = true;
        this.errorMessage = this.getScreenText('ERROR_LOGIN_RES');
      }
      else if (forgotPass.linkVerification.status == APP_CONST.RESPONSE_404) {
        this.errorBorder = true;
        this.errorMessage = this.getScreenText('ERROR_LOGIN_RES');
      }
    }

    onClose() {
      this.error = '';
      this.errorBorder = false;
      this.email = '';
    }

    clearEmail() {
      const elem: HTMLElement = document.getElementById('modal-close-default') as HTMLElement;
      elem && elem.scrollTo(0, 0);
      this.onClose();
    }

}
